import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { EventsService } from '@presentationServices';
import { EventItem } from '@shared';
import { catchError, of } from 'rxjs';

export const eventDetailResolver: ResolveFn<EventItem | null> = (route: ActivatedRouteSnapshot) => {
  const slug = route.paramMap.get('slug');
  if (!slug) {
    return of(null);
  }

  return inject(EventsService)
    .fetchEventBySlug(slug)
    .pipe(catchError(() => of(null)));
};
